module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet292-2560x1440.b4e7d06f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet292-2560x1440.jpg
// module id = 1041
// module chunks = 37